export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/login')
    },
    {
        path: '/reset-password',
        name: 'resetPassword',
        component: () => import('@/views/auth/resetPassword')
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: () => import('@/views/auth/forgotPassword')
    },
    {
        path: '/setting-password',
        name: 'settingPassword',
        component: () => import('@/views/auth/settingPassword')
    }
];
